import { $$ } from 'utils/dom';
import { observe } from '../video/video';

const $$audios = $$('.plyr-audio');
$$audios.length && observe($$audios);
